import { cva } from "class-variance-authority";
import * as React from "react";

import { cn, tw } from "../../utils/utils";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-blue-500 text-white hover:bg-blue-600 [&_svg]:text-white",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline:
          "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export const buttonVariantsOLD = cva(
  tw`inline-flex truncate items-center whitespace-nowrap justify-center font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none disabled:shadow-none`,
  {
    variants: {
      variant: {
        default: tw`!bg-green-500 text-white hover:!bg-green-500/90 focus-visible:ring-red`,
        secondary: tw`border border-emerald-500 text-emerald-500 hover:bg-emerald-100 focus-visible:ring-emerald-500`,
        alternative: tw`bg-blue-500 text-white hover:bg-blue-500/90 focus-visible:ring-blue-500`,
        alternativeSecondary: tw`bg-orange-500 text-white hover:bg-orange-500/90 focus-visible:ring-orange-500`,
        destructive: tw`bg-red-500 text-white hover:bg-red-500/90 focus-visible:ring-red`,
        outlined: tw`border bg-white border-gray-100 hover:bg-gray-50 text-gray-900 focus-visible:ring-gray-100`,
        "destructive-outlined": tw`border bg-white border-none hover:text-red-500 border-gray-100 text-gray-900 focus-visible:ring-gray-100`,
      },
      size: {
        sm: tw`px-2 h-8 rounded text-sm`,
        default: tw`px-3 h-10 rounded text-sm`,
        lg: tw`px-8 h-12 rounded text-sm`,
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export default function Button({ className, variant, size, ...props }) {
  return (
    <button
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  );
}
